import React from "react";
import popupsyle from "../../style/PopUp.module.css";
import { TfiClose } from "react-icons/tfi";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const PeopleView = ({ show, onClose, data }) => {
  if (!show) return null;
  const apiUrl = process.env.REACT_APP_API_URL;

  return (
    <div className={popupsyle.popupBackground}>
      <div className={popupsyle.popupPeopleView}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>{data.name}</h3>
            {/* <button onClick={onClose} className={popupsyle.closeButton}>
            ×
          </button> */}
            <TfiClose onClick={onClose} />
            {/* <div className={popupsyle.buttonClose}>x</div> */}
          </div>
          <div className={popupsyle.popupContent}>
            {data?.userList.map((emp, index) => (
              <div className={popupsyle.popupPeopleViewDiv}>
                {emp.emp_pic !== null ? (
                  <img
                    src={`${apiUrl}${emp.emp_pic}`}
                    className={popupsyle.popupPeopleViewIcon}
                    alt="img"
                  />
                ) : (
                  <FallbackAvatar name={`${data.name} `} size={30} />
                )}

                <p
                  style={{ fontSize: "14px" }}
                  className={popupsyle.headingColor}
                >{`${emp.name} `}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleView;
